<template>
  <el-dialog :visible.sync="dialogVisible" title="新增/编辑货位" width="30%" @closed="resetForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <!-- 所属仓库 -->
      <el-form-item label="所属仓库：" prop="warehouse_id">
        <el-select v-model="form.warehouse_id" placeholder="请选择仓库" style="width: 100%;" @change="selectwarehouse(['area', 'alleyNumber', 'shelf', 'level'])">
          <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 所属库区 -->
      <el-form-item label="所属库区：" prop="area">
        <el-select v-model="form.area" placeholder="请选择库区" style="width: 100%;" @change="selectwarehouse(['alleyNumber', 'shelf', 'level'])">
          <el-option v-for="item in areas" :key="item.id" :label="item.code" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 巷道号 -->
      <el-form-item label="巷道号：" prop="alleyNumber">
        <el-select v-model="form.alleyNumber" placeholder="请选择巷道号" style="width: 100%;" @change="selectwarehouse(['shelf', 'level'])">
          <el-option v-for="item in alleyNumbers" :key="item.id" :label="item.code" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 所属货架 -->
      <el-form-item label="所属货架：" prop="shelf">
        <el-select v-model="form.shelf" placeholder="请选择货架" style="width: 100%;" @change="selectwarehouse(['level'])">
          <el-option v-for="item in shelves" :key="item.id" :label="item.code" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 层数 -->
      <el-form-item label="层数：" prop="level">
        <el-select v-model="form.level" placeholder="请选择层数" style="width: 100%;">
          <el-option v-for="item in levels" :key="item.id" :label="item.code" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 货位 -->
      <el-form-item label="货位：" prop="position">
        <div style="display: flex;align-items: center;width: 100%;">
          <span style="flex-shrink: 0;">{{ warehouseName }}</span>
          <span style="flex-shrink: 0;">{{ areaName }}</span>
          <span style="flex-shrink: 0;">{{ alleyNumberName }}</span>
          <span style="flex-shrink: 0;">{{ shelfName }}</span>
          <span style="flex-shrink: 0;">{{ levelName }}</span>
          <el-input v-model="form.position" style="margin-left: 10px;" placeholder="请输入货位"></el-input>
        </div>
      </el-form-item>
      <!-- 状态 -->
      <el-form-item label="状态：" prop="status">
        <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
          :inactive-value="0" active-text="启用" inactive-text="禁用">
        </el-switch>
      </el-form-item>
      <!-- 状态 -->
      <el-form-item label="破损货位：">
        <el-checkbox v-model="form.is_damaged" :true-label="1" :false-label="0"></el-checkbox>
      </el-form-item>
      <!-- 备注 -->
      <el-form-item label="备注：">
        <el-input type="textarea" v-model="form.remarks"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="submitForm('form')">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: {
    treeData: {
      type: Array,
      default: () => []
    }
  },
  // 库区 =》 巷道 =》 货架 =》 货层 =》 货位
  computed: {
    // 根据仓库选中的id，获取库区数据
    areas() {
      if (this.form.warehouse_id) {
        return this.treeData.find(item => item.id === this.form.warehouse_id).children
      } else {
        return []
      }
    },
    // 根据库区获取巷道号列表
    alleyNumbers() {
      if (this.form.area) {
        const data = this.areas.find(item => item.id == this.form.area)
        if (data) {
          return data.children
        }
      }
      return []

    },
    // 根据巷道号获取货架列表
    shelves() {
      if (this.form.alleyNumber) {
        const data = this.alleyNumbers.find(item => item.id == this.form.alleyNumber)
        if (data) {
          return data.children
        }
      }
      return []
    },
    // 根据货架号获取货层列表
    levels() {
      if (this.form.shelf) {
        const data = this.shelves.find(item => item.id == this.form.shelf)
        if (data) {
          return data.children
        }
      }
      return []
    },
    warehouseName() {
      if (this.form.warehouse_id) {
        const data = this.treeData.find(item => item.id == this.form.warehouse_id)
        return (data && data.name) || ''
      }
    },
    areaName() {
      if (this.form.area) {
        const data = this.areas.find(item => item.id == this.form.area)
        return '-' + (data && data.code) || ''
      }
    },
    alleyNumberName() {
      if (this.form.alleyNumber) {
        const data = this.alleyNumbers.find(item => item.id == this.form.alleyNumber)
        return '-' + (data && data.code) || ''
      }
    },
    shelfName() {
      if (this.form.shelf) {
        const data = this.shelves.find(item => item.id == this.form.shelf)
        return '-' + (data && data.code) || ''
      }
    },
    levelName() {
      if (this.form.level) {
        const data = this.levels.find(item => item.id == this.form.level)
        return '-' + (data && data.code) || ''
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 下拉选项数据


      form: {
        warehouse_id: '',
        area: '',
        alleyNumber: '',
        shelf: '',
        level: '',
        position: '',
        status: 1,
        remarks: '',
        is_damaged: 0
      },
      rules: {
        warehouse_id: [{ required: true, message: '请选择所属仓库', trigger: 'change' }],
        area: [{ required: true, message: '请选择所属库区', trigger: 'change' }],
        alleyNumber: [{ required: true, message: '请选择巷道号', trigger: 'change' }],
        shelf: [{ required: true, message: '请选择所属货架', trigger: 'change' }],
        level: [{ required: true, message: '请选择层数', trigger: 'change' }],
        position: [{ required: true, message: '请输入货位', trigger: 'blur' }]
      }
    };
  },
  methods: {
    selectwarehouse(arr) {
      // const clearaName = ['area', 'alleyNumber', 'shelf', 'level', 'position']
      const clearaName = arr
      clearaName.forEach(item => {
        this.form[item] = ''
      })
    },
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.resetForm()
      });

    },
    resetForm() {
      this.form.remarks = ''
      this.form.is_damaged = 0
      this.$refs.form.resetFields();
      this.$refs.form.clearValidate();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 这里可以添加保存逻辑
          console.log(this.form, 'llllllllllllll')
          this.$axios({
            url: this.GLOBAL.domain + '/StorageLocation/save_location',
            method: 'POST',
            data: {
              warehouse_id: this.form.warehouse_id,
              type: 5,
              code: this.form.position,
              pid: this.form.level,
              status: this.form.status,
              is_damaged: this.form.is_damaged
            }
          }).then(res => {
            if (res) {
              this.$message.success(`新增成功`);
              this.dialogVisible = false;
              this.$emit('success');
            }
          })
          
        } else {
          console.log('表单验证失败!!');
          return false;
        }
      });
    },
    cancel() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
/* 根据需要添加样式 */
</style>


// WEBPACK FOOTER //
// src/components/inventory/StorageLocationModel.vue